import { Link } from "react-router-dom";
import { Zap, ArrowRight } from "lucide-react";
import { Section } from "@/components/common";

export const PowerStudyBanner = ({ testid = "power-study-banner" }) => (
  <Section className="py-6">
    <div data-testid={testid}
      className="relative overflow-hidden rounded-2xl border border-[#84CC16]/30 bg-gradient-to-r from-[#84CC16]/10 via-[#111827] to-[#111827] px-6 py-6 sm:px-8 flex flex-col md:flex-row md:items-center justify-between gap-5">
      <div className="flex items-start gap-4">
        <div className="shrink-0 w-11 h-11 rounded-xl bg-[#84CC16]/15 border border-[#84CC16]/30 flex items-center justify-center">
          <Zap size={22} className="text-[#84CC16]" />
        </div>
        <div>
          <p className="font-mono text-[10px] uppercase tracking-widest text-[#84CC16] mb-1">New · DYOR Power Feasibility Study</p>
          <p className="font-display font-bold text-lg sm:text-xl text-white leading-snug">
            Will your site actually get power? Order a DYOR Power Feasibility Study
          </p>
        </div>
      </div>
      <Link to="/power-study" data-testid={`${testid}-cta`}
        className="shrink-0 inline-flex items-center justify-center gap-2 bg-[#84CC16] hover:bg-[#9ee325] text-[#0B0F17] font-bold px-6 py-3 rounded-full transition-colors glow-lime">
        Order a Study <ArrowRight size={17} />
      </Link>
    </div>
  </Section>
);

export default PowerStudyBanner;
